import React from "react";
import UserMenu from "./header/userMenu.component";

function Header({ sidebarOpen, setSidebarOpen }) {
  return (
    <header className="sticky top-0 bg-white border-b z-20">
      <div className="px-4 sm:px-6 lg:px-8 py-2">
        <div className="flex items-center justify-between h-9 -mb-px">
          <div className="text-lg uppercase font-yantramanav tracking-widest">
            <strong>Gratitude</strong> - Forever Grateful
          </div>
          <UserMenu />
        </div>
      </div>
    </header>
  );
}

export default Header;
